"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchClearWarnings = exports.stytchSetWarning = exports.StytchWarningMessage = exports.StytchWarningSlot = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
var StytchWarningSlot;
(function (StytchWarningSlot) {
    StytchWarningSlot["GET_CURRENT_USER"] = "GET_CURRENT_USER";
    StytchWarningSlot["EMAIL_SIGN_IN"] = "EMAIL_SIGN_IN";
    StytchWarningSlot["EMAIL_SIGN_UP"] = "EMAIL_SIGN_UP";
    StytchWarningSlot["EMAIL_EXCHANGE_CODE"] = "EMAIL_EXCHANGE_CODE";
    StytchWarningSlot["EMAIL_RESEND_MESSAGE"] = "EMAIL_RESEND_MESSAGE";
    StytchWarningSlot["LOAD_AUTHENTICATION"] = "LOAD_AUTHENTICATION";
    StytchWarningSlot["PHONE_SIGN_IN"] = "PHONE_SIGN_IN";
    StytchWarningSlot["PHONE_SIGN_UP"] = "PHONE_SIGN_UP";
    StytchWarningSlot["PHONE_EXCHANGE_CODE"] = "PHONE_EXCHANGE_CODE";
    StytchWarningSlot["PHONE_RESEND_CODE"] = "PHONE_RESEND_CODE";
    StytchWarningSlot["SIGN_OUT"] = "SIGN_OUT";
    StytchWarningSlot["CRYPTO_SIGN_UP"] = "CRYPTO_SIGN_UP";
    StytchWarningSlot["CRYPTO_SIGN_IN"] = "CRYPTO_SIGN_IN";
    StytchWarningSlot["CRYPTO_EXCHANGE_CODE"] = "CRYPTO_EXCHANGE_CODE";
})(StytchWarningSlot = exports.StytchWarningSlot || (exports.StytchWarningSlot = {}));
var StytchWarningMessage;
(function (StytchWarningMessage) {
    StytchWarningMessage["GET_CURRENT_USER"] = "Failed to retreive the user";
    StytchWarningMessage["EMAIL_SIGN_IN"] = "Couldn't log into the user account";
    StytchWarningMessage["EMAIL_SIGN_UP"] = "Couldn't create user";
    StytchWarningMessage["EMAIL_EXCHANGE_CODE"] = "Couldn't exchange code";
    StytchWarningMessage["EMAIL_RESEND_MESSAGE"] = "Couldn't send the message";
    StytchWarningMessage["EMAIL_RESEND_MESSAGE_TOO_SOON"] = "The email was sent too recently. Try again in a couple of minutes";
    StytchWarningMessage["LOAD_AUTHENTICATION"] = "Failed to load account";
    StytchWarningMessage["PHONE_SIGN_IN"] = "Couldn't log into the user account";
    StytchWarningMessage["PHONE_SIGN_UP"] = "Couldn't create user";
    StytchWarningMessage["PHONE_EXCHANGE_CODE"] = "Couldn't exchange code";
    StytchWarningMessage["PHONE_RESEND_CODE"] = "Couldn't send the code";
    StytchWarningMessage["PHONE_RESEND_CODE_TOO_SOON"] = "The code was sent too recently. Try again in a couple of minutes";
    StytchWarningMessage["SIGN_OUT"] = "Failed to sign out";
    StytchWarningMessage["CRYPTO_SIGN_UP"] = "Couldn't create user";
    StytchWarningMessage["CRYPTO_SIGN_IN"] = "Couldn't log into the user account";
    StytchWarningMessage["CRYPTO_EXCHANGE_CODE"] = "CRYPTO_EXCHANGE_CODE";
})(StytchWarningMessage = exports.StytchWarningMessage || (exports.StytchWarningMessage = {}));
exports.stytchSetWarning = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/SET_WARNING');
exports.stytchClearWarnings = (0, toolkit_1.createAction)('AUTHENTICATION/STYTCH/CLEAR_WARNINGS');
